import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const withdraw_augmontApi = createAsyncThunk("withdraw_augmont", async () => {
  const response = await axiosInstance.get("/withdraw_augmont");
  return response.data;
});

const withdraw_augmontSlice = createSlice({
  name: "withdraw_augmont",
  initialState: {
    withdraw_augmont: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(withdraw_augmontApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(withdraw_augmontApi.fulfilled, (state, action) => {
        state.withdraw_augmont = action.payload;
        state.loading = false;
      })
      .addCase(withdraw_augmontApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default withdraw_augmontSlice.reducer;
